import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/industries/ambulance-emergency/page.tsx");
